import { useStore } from "@tanstack/react-form";

import { useFieldContext } from "..";
import { Input } from "../../ui/input";
import { getErrorMessage } from "../utils";
import FieldWrapper from "./FieldWrapper";

type InputFieldProps = {
  label?: string;
  subLabel?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const InputField = ({
  label,
  subLabel,
  required,
  ...inputProps
}: InputFieldProps) => {
  const field = useFieldContext<string>();

  const errors = useStore(field.store, (state) => state.meta.errors);

  const hasError = errors.length > 0 && field.state.meta.isDirty;

  return (
    <FieldWrapper
      id={field.name}
      label={label}
      subLabel={subLabel}
      isRequired={required}
      errorMessage={hasError ? getErrorMessage(errors[0]) : undefined}
    >
      <Input
        id={field.name}
        value={field?.state?.value}
        aria-invalid={hasError}
        onBlur={field.handleBlur}
        onChange={(e) => field.handleChange(e.target.value)}
        {...inputProps}
      />
    </FieldWrapper>
  );
};
